import { Theme } from '@config/themes/ITheme';
import crashTheme from '@config/themes/crash.theme'; // 1. Import the base theme

// 2. Create the new theme by extending the base theme and overriding specific values
export const crashAltTheme: Theme = {
  ...crashTheme, // Start with all values from the base theme

  // Override the 'colors' object
  colors: {
    ...crashTheme.colors, // Inherit all base colors first
    background: '#0F172A',
    primary: '#38BDF8',
    secondary: '#334155',
    text: '#E2E8F0', // Adjusted for better contrast
    warning: '#F59E0B',
    success: '#22C55E',
    danger: '#EF4444',
    overlay: 'rgba(10, 10, 20, 0.75)',
    border: 'rgba(51, 65, 85, 0.8)',
  },

  // Override the 'fonts' object
  fonts: {
    ...crashTheme.fonts, // Inherit base fonts
    secondary: "'Orbitron', sans-serif", // Only change the secondary font
  },

  // Override the 'uiElements' object
  uiElements: {
    ...crashTheme.uiElements, // Inherit all base UI elements (including 'spacing')
    button: {
      ...crashTheme.uiElements.button, // Inherit base button styles
      borderRadius: '6px',
      padding: '14px 28px',
      fontSize: '15px',
    },
    card: {
      ...crashTheme.uiElements.card, // Inherit base card styles
      borderRadius: '10px',
      shadow: '0 6px 24px rgba(233, 69, 96, 0.1)',
    },
    modal: {
      ...crashTheme.uiElements.modal, // Inherit base modal styles
      borderRadius: '12px',
      background: '#16213e',
    },
  },
};
export default crashAltTheme;
